import type { StatusTone } from '@/shared/ui/status-badge'

interface StatusMeta {
  label: string
  tone: StatusTone
}

const voiceStatuses: Record<string, StatusMeta> = {
  ready: { label: 'Готов', tone: 'ok' },
  processing: { label: 'Обработка', tone: 'info' },
  failed: { label: 'Сбой', tone: 'danger' },
}

export function voiceStatus(status: string): StatusMeta {
  return voiceStatuses[status] ?? { label: status || '—', tone: 'muted' }
}

export const voiceLangLabels: Record<string, string> = {
  ru: 'Русский',
  en: 'Английский',
  ar: 'Арабский',
}
